import { Controller } from "@hotwired/stimulus"

// Anchors the phone field to a non-erasable leading "+" and restricts the rest
// to digits, so what the user types stays close to the E.164 form the server
// normalizes to. Runs on every edit (typing, paste, cut, autofill) and once on
// connect to clean up any server-provided value.
export default class extends Controller {
  connect() {
    this.sanitize()
  }

  sanitize() {
    const input = this.element
    const previous = input.value

    // Remember how many digits sat before the caret so we can restore it after
    // rewriting the value.
    const digitsBeforeCaret = (previous.slice(0, input.selectionStart).match(/\d/g) || []).length

    const next = "+" + previous.replace(/\D/g, "")
    if (next !== previous) {
      input.value = next
    }

    // "+" occupies index 0, so the caret sits after the Nth digit at N + 1.
    const caret = digitsBeforeCaret + 1
    input.setSelectionRange(caret, caret)
  }
}
